










import { ConversaoMedidasDTO } from '@/interfaces/product';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';

@Component({
  components: {
    GChart,
  },
})
export default class ProductChart extends BaseComponent {
  @Prop()
  public item: ConversaoMedidasDTO;
  @Prop()
  public mini: boolean;

  private chartOptions = {
    backgroundColor: 'transparent',
    width: 200,
    height: 70,
    chartArea: { width: '100%', height: '100%'},
    legend: { position: 'labeled', text: 'value', textStyle: { color: 'black' /*fontSize: 15*/ } },
    fontSize: 12,
    //pieSliceText: 'label',
    //legend: 'none',
    pieSliceText: 'none',
    //tooltip: {ignoreBounds: false, trigger: 'selection', showColorCode: true, text: 'value'},
    tooltip: { trigger: 'none' },
    slices: [{ color: '102D69' }, { color: 'F5B830' }],
  };

  private chartOptionsMini = {
    backgroundColor: 'transparent',
    //width: 250,
    height: 40,
    chartArea: { width: '100%', height: '100%' },
    legend: { position: 'none' },
    fontSize: 7,
    //pieSliceText: 'label',
    //legend: 'none',
    pieSliceText: 'percentage',
    tooltip: { trigger: 'none' },
    slices: [{ color: '102D69' }, { color: 'F5B830' }],
    enableInteractivity: false
  };

  private getChartOptions() {
    if (this.mini) {
      return this.chartOptionsMini;
    } else {
      return this.chartOptions;
    }
  }

  private getChartData() {
    let chartData = [];
    chartData.push(['Nutrição', 'Quantidade']);
    if (this.item) {
      chartData.push(['Resultado', (1 - this.item.proporcaoEnteral) * 100]);
      chartData.push(['Descontado', this.item.proporcaoEnteral * 100]);
    }
    return chartData;
  }
}
